import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ListGroup from 'react-bootstrap/ListGroup'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import { Formik } from 'formik'

// Actions
import {
  configuracionFormAction,
  obtenerTareasAction,
  obtenerEstadosCasoAction,
  obtenerTipoGestionAction,
  obtenerSituacionSiniestroAction,
  obtenerDeclaracionPolicialAction,
  obtenerCriteriosFechaAction,
  obtenerTareasUsuarioAction,
  obtenerCasosBandeja,
  obtenerRangoFechas,
  limpiarCasosBandeja
} from '../../store/actions/encargado-cia-action'

// Custom Components
import 'recupero-comunes/dist/index.css'
import {
  Auth,
  LoadingComponent,
  SelectRadioComponent,
  SelectComponent,
  InputDateComponent,
  InputRadioComponent,
  CheckboxComponent
} from 'recupero-comunes'

// Custom Validation Schema
import { buscarCasosFormSchema } from '../../common/validation-schemas'
import { useLocation } from 'react-router-dom'

const BuscarCasos = ({ setFormSubmitValues }) => {
  const { rutUsuario, rutOrganizacion } = Auth.currentUser()
  const { state } = useLocation()
  const [dataIntegration, setDataIntegration] = useState(null)

  const selects = [
    'tarea',
    'estadocaso',
    'tipogestion',
    'situacionsiniestro',
    'declaracion',
    'tipofecha'
  ]
  const refs = useRef(selects.map(() => React.createRef()))

  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState({})
  const [checked, setChecked] = useState({})
  const [required, setRequired] = useState({
    fechadesde: true,
    fechahasta: true,
    tipofecha: true
  })
  const [fechas, setFechas] = useState({ desde: '', hasta: '' })

  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {
    cfg_form,
    rangofechas,
    tareas,
    estadocaso,
    tipogestion,
    situacionsiniestro,
    declaracionpolicial,
    criteriofecha,
    tareasusuario
  } = data_encargado_cia

  // El hook useDispatch (redux) permite invocar una action.
  const dispatch = useDispatch()

  useEffect(() => {
    // @TODO: reemplazar valor estáticos.
    let query = Buffer.from(
      JSON.stringify({ idform: 1, rutcia: rutOrganizacion })
    ).toString('base64')
    dispatch(configuracionFormAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, parametro: 1 })
    ).toString('base64')
    dispatch(obtenerRangoFechas(query))
  }, [dispatch])

  useEffect(() => {
    setRangoFechas(rangofechas)
  }, [rangofechas])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({
        rutcia: rutOrganizacion,
        rutusr: rutUsuario,
        flujo: 1,
        todos: document.getElementById('todos')
          ? document.getElementById('todos').checked
          : false
      })
    ).toString('base64')
    dispatch(obtenerTareasAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, concepto: 200 })
    ).toString('base64')
    dispatch(obtenerEstadosCasoAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, concepto: 207 })
    ).toString('base64')
    dispatch(obtenerTipoGestionAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, concepto: 201 })
    ).toString('base64')
    dispatch(obtenerSituacionSiniestroAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, concepto: 202 })
    ).toString('base64')
    dispatch(obtenerDeclaracionPolicialAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, concepto: 29 })
    ).toString('base64')
    dispatch(obtenerCriteriosFechaAction(query))
  }, [dispatch])

  useEffect(() => {
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 1 })
    ).toString('base64')
    dispatch(obtenerTareasUsuarioAction(query))
  }, [dispatch])

  useEffect(() => {
    if (dataIntegration) {
      setFormSubmitValues(dataIntegration)
      setLoading(true)
      dispatch(
        obtenerCasosBandeja(
          Buffer.from(JSON.stringify(state.formValues)).toString('base64')
        )
      ).then(() => {
        setLoading(false)
      })
      setDataIntegration(null)
    }
  }, [])

  const obtenerTareasUsuarioOriginal = () => {
    let query = Buffer.from(
      JSON.stringify({
        rutcia: rutOrganizacion,
        rutusr: rutUsuario,
        flujo: 1
      })
    ).toString('base64')
    dispatch(obtenerTareasUsuarioAction(query))
  }
  const obtenerTareasUsuario = () => {
    let query = Buffer.from(
      JSON.stringify({
        rutcia: rutOrganizacion,
        rutusr: rutUsuario,
        flujo: 1
      })
    ).toString('base64')
    setLoading(true)
    dispatch(
      obtenerTareasUsuarioAction(query)
    ).then(() => {

      let queryTareas = Buffer.from(
        JSON.stringify({
          rutcia: rutOrganizacion,
          rutusr: rutUsuario,
          flujo: 1,
          todos: document.getElementById('todos')
            ? document.getElementById('todos').checked
            : false
        })
      ).toString('base64')
      dispatch(
        obtenerTareasAction(queryTareas)
      ).then(() => {
          setLoading(false)
      })
    })
  }
  const evaluarFiltros = (name, values, setFieldValue, resetForm) => {
    // Limpiar formulario
    resetForm()

    // Conservar último valor del campo en foco.
    setFieldValue([name], values[name])

    // Limpiar campos select
    limpiarSelect(name)

    // Habilitar/Checkear campos sugún selección
    let new_disabled = { ...disabled }
    let new_checked = { ...checked }

    for (let key in values) {
      new_disabled[key] = key !== name
      new_checked[key] = key === name
    }

    setFechas({ desde: '', hasta: '' })
    setRequired({ [name]: true })
    setDisabled(new_disabled)
    setChecked(new_checked)
  }

  const limpiarSelect = (name) => {
    selects.map((_name, index) => {
      _name !== name && refs.current[index].current.clear()
    })
  }

  const onResetForm = (resetForm) => {
    resetForm()
    setDisabled({})
    setChecked({})
    setRequired({ fechadesde: true, fechahasta: true, tipofecha: true })
    setRangoFechas(rangofechas)
    selects.map((name, index) => {
      refs.current[index].current.clear()
    })
    document.getElementById('todos').checked = false
    document.getElementById('salvatajevisado').checked = false
    dispatch(limpiarCasosBandeja())
  }

  const setRangoFechas = (rangofechas) => {
    if (rangofechas) {
      let hasta = new Date()
      let desde = new Date()
      desde.setMonth(hasta.getMonth() - rangofechas.valorParametro)
      setFechas({
        desde: desde.toLocaleDateString('en-CA'),
        hasta: hasta.toLocaleDateString('en-CA')
      })
    }
  }

  const onSubmit = (values) => {
    setLoading(true)
    let query = { rutcia: rutOrganizacion, rutusr: rutUsuario }
    for (let key in values) {
      if (values[key] !== null && values[key] !== '') {
        query[key] = values[key]
      } else if (key === 'fechadesde' || key === 'fechahasta') {
        if (fechas[key.replace('fecha', '')] !== '') {
          query[key] = fechas[key.replace('fecha', '')]
        }
      }
    }
    
    setFormSubmitValues(query)
    query = Buffer.from(JSON.stringify(query)).toString('base64')
    dispatch(obtenerCasosBandeja(query)).then(() => {
      setLoading(false)
    })
  }

  const onSubmitByColor = (color) => {
    setLoading(true)
    let query = Buffer.from(
      JSON.stringify({
        rutcia: rutOrganizacion,
        rutusr: rutUsuario,
        todos: document.getElementById('todos')
          ? document.getElementById('todos').checked
          : false,
        color: color
      })
    ).toString('base64')
    dispatch(obtenerCasosBandeja(query)).then(() => {
      setLoading(false)
      setFormValues(query)
    })
  }

  return (
    <div>
      <LoadingComponent show={loading} />
      <Formik
        initialValues={{
          tarea: '',
          estadocaso: '',

          tipogestion: '',
          todos: false,
          situacionsiniestro: '',
          declaracion: '',
          salvatajevisado: false,
          fechadesde: '',
          fechahasta: '',
          tipofecha: '',
          siniestro: '',
          patente: '',
          idcaso: ''
        }}
        validationSchema={buscarCasosFormSchema(required, fechas)}
        initialTouched={{
          tarea: false,
          estadocaso: false,
          situacionsiniestro: false,
          declaracion: false,
          tipofecha: false
        }}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={onSubmit}
      >
        {({ values, handleSubmit, setFieldValue, resetForm }) => (
          <Form noValidate onSubmit={handleSubmit}>
            {cfg_form ? (
              <div>
                <Row className='mt-4'>
                  <Col md='4'>
                    <SelectRadioComponent
                      ref={refs.current[selects.indexOf('tarea')]}
                      name='tarea'
                      label={cfg_form['bandejatareas-filtro-tareaspendientes']}
                      labelKey='nombre'
                      options={tareas ? tareas : []}
                      onFocus={(e) =>
                        evaluarFiltros(
                          'tarea',
                          values,
                          setFieldValue,
                          resetForm
                        )
                      }
                      defaultInputValue={
                        tareas?.length > 0
                          ? tareas.find(
                              (element) =>
                                element?.id === state?.formValues?.tarea
                            )?.nombre
                          : ''
                      }
                      disabled={disabled['tarea']}
                      checked={checked['tarea']}
                    />
                  </Col>
                  <Col md='3'>
                    <SelectRadioComponent
                      ref={refs.current[selects.indexOf('estadocaso')]}
                      name='estadocaso'
                      label={cfg_form['bandejatareas-filtro-estadocaso']}
                      labelKey='nombre'
                      options={estadocaso ? estadocaso : []}
                      onFocus={(e) =>
                        evaluarFiltros(
                          'estadocaso',
                          values,
                          setFieldValue,
                          resetForm
                        )
                      }
                      defaultInputValue={
                        estadocaso?.length > 0
                          ? estadocaso.find(
                              (element) =>
                                element?.id === state?.formValues?.estadocaso
                            )?.nombre
                          : ''
                      }
                      disabled={disabled['estadocaso']}
                      checked={checked['estadocaso']}
                    />
                  </Col>
                  <Col md='3'>
                    <SelectComponent
                      ref={refs.current[selects.indexOf('tipogestion')]}
                      name='tipogestion'
                      label={cfg_form['bandejatareas-filtro-tipogestion']}
                      labelKey='nombre'
                      options={tipogestion ? tipogestion : []}
                      disabled={disabled['tipogestion']}
                      defaultInputValue={
                        tipogestion?.length > 0
                          ? tipogestion.find(
                              (element) =>
                                element?.id === state?.formValues?.tipogestion
                            )?.nombre
                          : ''
                      }
                    />
                  </Col>
                  <Col md='2'>
                    <CheckboxComponent
                      name='todos'
                      label={cfg_form['bandejatareas-filtro-todoscasos']}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md='9'>
                    <Row className='mt-4'>
                      <Col md='4'>
                        <SelectComponent
                          ref={
                            refs.current[selects.indexOf('situacionsiniestro')]
                          }
                          name='situacionsiniestro'
                          label={
                            cfg_form['bandejatareas-filtro-situacionsiniestro']
                          }
                          labelKey='nombre'
                          options={situacionsiniestro ? situacionsiniestro : []}
                          disabled={disabled['situacionsiniestro']}
                          defaultInputValue={
                            situacionsiniestro?.length > 0
                              ? situacionsiniestro.find(
                                  (element) =>
                                    element?.id ===
                                    state?.formValues?.situacionsiniestro
                                )?.nombre
                              : ''
                          }
                        />
                      </Col>
                      <Col md='4'>
                        <SelectComponent
                          ref={refs.current[selects.indexOf('declaracion')]}
                          name='declaracion'
                          label={
                            cfg_form['bandejatareas-filtro-declaracionpolicial']
                          }
                          labelKey='nombre'
                          options={
                            declaracionpolicial ? declaracionpolicial : []
                          }
                          disabled={disabled['declaracion']}
                          defaultInputValue={
                            declaracionpolicial?.length > 0
                              ? declaracionpolicial.find(
                                  (element) =>
                                    element?.id ===
                                    state?.formValues?.declaracion
                                )?.nombre
                              : ''
                          }
                        />
                      </Col>
                      <Col md='4'>
                        <CheckboxComponent
                          name='salvatajevisado'
                          label={
                            cfg_form['bandejatareas-filtro-salvatajevisado']
                          }
                        />
                      </Col>
                    </Row>
                    <Row className='mt-4'>
                      <Col md='4'>
                        <InputDateComponent
                          name='fechadesde'
                          label={cfg_form['bandejatareas-filtro-fechadesde']}
                          disabled={disabled['fechadesde']}
                          defaultValue={fechas.desde}
                        />
                      </Col>
                      <Col md='4'>
                        <InputDateComponent
                          name='fechahasta'
                          label={cfg_form['bandejatareas-filtro-fechahasta']}
                          disabled={disabled['fechahasta']}
                          defaultValue={fechas.hasta}
                        />
                      </Col>
                      <Col md='4'>
                        <SelectComponent
                          ref={refs.current[selects.indexOf('tipofecha')]}
                          name='tipofecha'
                          label={cfg_form['bandejatareas-filtro-criteriofecha']}
                          labelKey='nombre'
                          options={criteriofecha ? criteriofecha : []}
                          disabled={disabled['tipofecha']}
                          defaultInputValue={
                            criteriofecha?.length > 0
                              ? criteriofecha.find(
                                  (element) =>
                                    element?.id ===
                                    state?.formValues?.criteriofecha
                                )?.nombre
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                    <Row className='mt-4'>
                      <Col>
                        <InputRadioComponent
                          name='siniestro'
                          type='number'
                          label={cfg_form['bandejatareas-filtro-siniestro']}
                          onFocus={(e) =>
                            evaluarFiltros(
                              'siniestro',
                              values,
                              setFieldValue,
                              resetForm
                            )
                          }
                          disabled={disabled['siniestro']}
                          checked={checked['siniestro']}
                        />
                      </Col>
                      <Col>
                        <InputRadioComponent
                          name='patente'
                          label={cfg_form['bandejatareas-filtro-patente']}
                          maxLength='6'
                          onFocus={(e) =>
                            evaluarFiltros(
                              'patente',
                              values,
                              setFieldValue,
                              resetForm
                            )
                          }
                          disabled={disabled['patente']}
                          checked={checked['patente']}
                        />
                      </Col>
                      <Col>
                        <InputRadioComponent
                          name='idcaso'
                          type='number'
                          label={cfg_form['bandejatareas-filtro-idcaso']}
                          onFocus={(e) =>
                            evaluarFiltros(
                              'idcaso',
                              values,
                              setFieldValue,
                              resetForm
                            )
                          }
                          disabled={disabled['idcaso']}
                          checked={checked['idcaso']}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md='3' className='align-self-center'>
                    <ListGroup>
                      <ListGroup.Item
                        action
                        className='text-center'
                        onClick={() => {
                          obtenerTareasUsuario()
                        }}
                        type='button'
                      >
                        <Row>
                          <Col>
                            <span className='fw-bolder me-2'>
                              {cfg_form['bandejatareas-semaforo-titulo']}
                            </span>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='16'
                              height='16'
                              fill='currentColor'
                              className='bi bi-arrow-clockwise'
                              viewBox='0 0 16 16'
                            >
                              <path
                                fillRule='evenodd'
                                d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
                              />
                              <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
                            </svg>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        variant='danger'
                        className='text-center'
                        onClick={() => onSubmitByColor('rojo')}
                        type='button'
                      >
                        <Row>
                          <Col>{tareasusuario && tareasusuario[0].nivel1}</Col>
                          <Col>
                            <Badge bg='danger'>
                              {tareasusuario && tareasusuario[0].rojo}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        variant='warning'
                        className='text-center'
                        onClick={() => onSubmitByColor('amarillo')}
                        type='button'
                      >
                        <Row>
                          <Col>{tareasusuario && tareasusuario[0].nivel2}</Col>
                          <Col>
                            <Badge bg='warning'>
                              {tareasusuario && tareasusuario[0].amarillo}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item
                        action
                        variant='success'
                        className='text-center'
                        onClick={() => onSubmitByColor('verde')}
                        type='button'
                      >
                        <Row>
                          <Col>{tareasusuario && tareasusuario[0].nivel3}</Col>
                          <Col>
                            <Badge bg='success'>
                              {tareasusuario && tareasusuario[0].verde}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                      <ListGroup.Item className='text-center'>
                        <Row>
                          <Col>Total</Col>
                          <Col>
                            <Badge>
                              {tareasusuario && tareasusuario[0].total}
                            </Badge>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    </ListGroup>
                  </Col>
                </Row>

                <hr className='mt-4' />

                <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
                  <Button
                    className='me-md-2'
                    variant='warning'
                    type='button'
                    onClick={() => {
                      onResetForm(resetForm)
                    }}
                  >
                    {cfg_form['bandejatareas-boton-limpiar']}
                  </Button>
                  <Button variant='danger' type='submit'>
                    {cfg_form['bandejatareas-boton-buscar']}
                  </Button>
                </div>
              </div>
            ) : null}
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default BuscarCasos
